import { useSyncExternalStore } from 'react';
import { useSiteVisitRecordingStore } from '@store/siteVisitRecordingStore';
import {
	isSiteVisitRecordingSessionActive,
	subscribeSiteVisitRecordingEngine,
} from '@services/siteVisitRecording/siteVisitRecordingEngine';

export function useSiteVisitRecordingSessionState(): {
	isActive: boolean;
	phase: ReturnType<typeof useSiteVisitRecordingStore.getState>['phase'];
	displayTime: string;
	isSaving: boolean;
} {
	const isActive = useSyncExternalStore(
		subscribeSiteVisitRecordingEngine,
		isSiteVisitRecordingSessionActive,
		() => false
	);
	const phase = useSiteVisitRecordingStore((s) => s.phase);
	const displayTime = useSiteVisitRecordingStore((s) => s.displayTime);
	const isSaving = useSiteVisitRecordingStore((s) => s.isSaving);

	return { isActive, phase, displayTime, isSaving };
}
